import {createFeatureSelector, createSelector} from "@ngrx/store";
import {HangarQueueFeatureKey} from "./hangar-queue.reducer";
import {HangarQueue} from "../../models/HangarQueue";

export const HangarQueueSelector = createFeatureSelector<HangarQueue[]>(HangarQueueFeatureKey);
